import { Injectable } from '@angular/core';
import { IAdapter } from 'src/app/models';
import { Eco } from 'src/app/models/domain';
import { YPMDOCUMENTVCDSYpmDocumentVType } from 'src/generated-clients/document';

@Injectable({
  providedIn: 'root',
})
export class EcoAdapter implements IAdapter<Eco, YPMDOCUMENTVCDSYpmDocumentVType> {
  public adaptToDomain(item: YPMDOCUMENTVCDSYpmDocumentVType): Eco {
    return new Eco(
      item.ObjectKey ?? '',
      item.DocumentFormat ?? '',
      item.Link ? item.Link : undefined
    );
  }
}
